export const TRANSPOREON_PRODUCT_NAME = 'Transporeon Visibility';
export const TRIMBLE_PRODUCT_NAME = 'Trimble Freight Visibility';
export const SHORT_PRODUCT_NAME = 'Freight Visibility';
